export default {"src":"/_next/static/media/logo.619e421b.svg","height":18,"width":97,"blurWidth":0,"blurHeight":0};